<app-popup-layout #modal>
  <div class="container m-0 p-0">
    <div class="row m-0 p-0">
      <div class="col-sm-12 m-0 p-0 d-flex flex-col">
        <header class="modal-header mb-8">
          <p class="modal-title">Request Summary</p>
          <app-close-button class="ms-auto" (onCloseEmitter)="modal.dismiss()"></app-close-button>
        </header>
      </div>

      <div class="modal-body form-group m-0 pt-0">
        <section class="d-flex mb-8" style="background: #F7F8F9 0% 0% no-repeat padding-box;
        border-radius: 8px;
        padding: 15px;">
          <div style="flex: 1">
            <p class="m-0 p-0 modal-body-title">Request Name</p>
            <p class="modal-body-subtitle"> {{
              approvalDetail.name
              | doubleDashForEmptyValues
            }}</p>
          </div>

          <div style="flex: 1">
            <p class="m-0 p-0 modal-body-title">Request Period</p>
            <p class="modal-body-subtitle">
              <span>
                {{
                approvalDetail.startDate
                | date : "mediumDate"
                | doubleDashForEmptyValues
                }}
              </span>
              -
              <span>
                {{
                approvalDetail.endDate
                | date : "mediumDate"
                | doubleDashForEmptyValues
                }}
              </span>
            </p>
          </div>

          <div style="flex: 1">
            <p class="m-0 p-0 modal-body-title">Advanced Required</p>
            <p class="modal-body-subtitle">
              {{approvalDetail?.advanceRequired ? 'Yes' : 'No'}}
            </p>
          </div>
        </section>
        <form>


          <p class="modal-body-title">
            <span style="font-weight: 600">Request Type Details</span>
          </p>

          <div class="custom-table-container">
            <!-- <div class="custom-table-header-container">
            <div class="custom-table-column" fxFlex="85">Details</div>
            <div class="custom-table-column" fxFlex="15">Amount</div>

          </div> -->

          <div class="custom-table-body-container" style="overflow-y: auto; height: 220px">
            <ng-container>
              @for (
                item of approvalDetail?.tripRequestResponses; track
                item; let i = $index) {
                <div class="custom-table-body-row">
                  <div class="custom-table-column align-self-center d-flex"
                    style="column-gap: 10px; align-items: center;flex-wrap: wrap;row-gap: 5px;" fxFlex="85">
                    @if (item.requestType === 'PURCHASE') {
                      <span style="    background: #2500D7 0% 0% no-repeat padding-box;
                    color: white;
                    display: inline-block;
                    border-radius: 50%;
                    width: 24px;
                    height: 24px;
                    display: flex;
                    align-items: center;
                    justify-content: center;">{{i+1}}
                      </span>
                      <div class="list-item-content">
                        {{ item?.requestType | titleCaseUnderscore }} ({{item?.purchaseCategory | titleCaseUnderscore}})
                      </div>
                    }
                    @if (item.requestType === 'IMPREST') {
                      <span style="    background: #2500D7 0% 0% no-repeat padding-box;
                    color: white;
                    display: inline-block;
                    border-radius: 50%;
                    width: 24px;
                    height: 24px;
                    display: flex;
                    align-items: center;
                    justify-content: center;">{{i+1}}
                      </span>
                      <div class="list-item-content">
                        {{ item?.requestType | titleCaseUnderscore }}
                      </div>
                    }
                    @if (item.requestType === 'TRIP') {
                      <span style="    background: #2500D7 0% 0% no-repeat padding-box;
                    color: white;
                    display: inline-block;
                    border-radius: 50%;
                    width: 24px;
                    height: 24px;
                    display: flex;
                    align-items: center;
                    justify-content: center;">{{i+1}}
                      </span>
                      <div class="list-item-content">
                        {{ item?.requestType | titleCaseUnderscore }} ({{item?.tripRequestType | titleCaseUnderscore}})
                      </div>
                      @if (item?.tripRequestType === 'TRAVEL') {
                        <p class="details-text">{{item?.tripRequestTravelType}} &nbsp; {{item?.source | titleCaseUnderscore}} -
                          {{item?.destination | titleCaseUnderscore}} &nbsp;
                          {{ item.dateOfJourney
                          | date : "mediumDate"
                          | doubleDashForEmptyValues}}
                        </p>
                      }
                      @if (item?.tripRequestType === 'FOOD') {
                        <p class="details-text">{{item?.mealType | titleCaseUnderscore}} &nbsp; {{ item.mealDate
                          | date : "mediumDate"
                          | doubleDashForEmptyValues}} &nbsp; {{item?.city | titleCaseUnderscore}}
                        </p>
                      }
                      @if (item?.tripRequestType === 'ACCOMODATION') {
                        <p class="details-text">{{item?.stayStartDate | date : "mediumDate"
                          | doubleDashForEmptyValues}} - {{item?.stayEndDate | date : "mediumDate"
                          | doubleDashForEmptyValues}} &nbsp;
                          {{ item.city | doubleDashForEmptyValues}}
                        </p>
                      }
                    }
                  </div>
                  <div class="custom-table-column align-self-center" fxFlex="15">
                    <div class="list-item-content">
                      {{ item?.amount |
                      doubleDashForEmptyValues}}
                    </div>
                  </div>
                </div>
              }
            </ng-container>
          </div>
          <div class="custom-table-footer-container align-items-center">
            <p class="m-0 p-0 modal-body-subtitle" style="flex: 4;">Advance Amount</p>
            <p class="p-0 m-0 modal-body-subtitle" style="flex: 0.5;">


              {{ approvalDetail?.totalAmount |
              doubleDashForEmptyValues}}

            </p>
          </div>

          <!-- <section class="d-flex justify-content-end mt-8">
          <div>
            <button type="button" class="hollow-button inline-block w-auto">

              Submit
            </button>
          </div>
        </section> -->
      </div>
    </form>
  </div>
</div>
</div>
</app-popup-layout>